export default __webpack_public_path__ + "static/media/PayPending.16a3240e.svg";